import { useEffect } from 'react';
import Media, { MediaType, MediaOptions } from '../common/media';
import uid from 'uid';

// const useMedia = (resourceUID: string = uid(), type: MediaType = MediaType.Audio, options?: MediaOptions) => {
//   const [media, setMedia] = useState<Media | undefined>(Media.getMediaFor(resourceUID, type, options));

//   useEffect(() => {
//     let isMounted = true;
//     if (media) {
//       media.on(MediaEvents.Destroy, () => {
//         if (isMounted) {
//           setMedia(undefined);
//         }
//       });
//     }

//     return () => {
//       media?.destroy();
//       isMounted = false;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return media;
// };

const useMedia = (resourceUID: string = uid(), type: MediaType = MediaType.Audio, options?: MediaOptions) => {
  const media = Media.getMediaFor(resourceUID, type, options);

  useEffect(
    () => () => {
      media.pause();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return media;
};

export default useMedia;
